import { useEffect, useState, FunctionComponent, MouseEvent } from 'react'

import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant'
import { dismissPopover } from 'services/OverlayService'
import { ActHoverIconDetails } from 'interfaces/legislation'
import { HoverIconButtonContainerProps } from 'redux/containers/components/accordion/HoverIconButtonContainer'
import TealToolTip from 'components/TealToolTip'

const HoverIconButton:FunctionComponent<HoverIconButtonProps> = ({ actHoverIconMap, nodeId }) => {
  const [details, setDetails] = useState<ActHoverIconDetails>()
  const [hover, setHover] = useState(false)

  useEffect(() => {
    if (actHoverIconMap) {
      const path = nodeId.split('/')
      const id = path[path.length - 1]
      const details = actHoverIconMap.get(id)

      setDetails(details)
    }
  }, [actHoverIconMap, nodeId])

  const handleOnClick = (e: MouseEvent<HTMLElement>):void => {
    dismissPopover(e.target)
    e.stopPropagation()
  }

  return !details ? null : (
    <div className='relative'>
      <TealToolTip
        open={hover}
        title={details.hoverIcon.iconDescription}
        placement='top'
        classes={{ tooltip: 'max-w-none' }}
      >
        <Link href={hover ? details.hoverIcon.externallink : null} target='_blank' rel='noopener noreferrer'>
          <IconButton
            size='small'
            onClick={handleOnClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {hover && details.hoverIcon.externallink
              ? <ArrowForwardIcon className='teal' />
              : <NotificationImportantIcon classes={{ root: 'dark-coral' }} />}
          </IconButton>
        </Link>
      </TealToolTip>
    </div>
  )
}

interface HoverIconButtonProps extends HoverIconButtonContainerProps{
  nodeId: string;
}

export default HoverIconButton
